import { computedCallingPlans } from '@/common/service/computers/plans/pbx';
import store from '@/store/index';
import { validateDeviceLicense, validateDeviceMaxLicense, DEVICE_VALIDATE_MODAL } from '@/flows/helper/vendor-product';
import { planTypes } from '@/common/constants';
// import { softBundleUtils } from '@/views/config/soft-bundle/helper';

export const validateZmHardware = async (options = {}) => {
  const { emitMessage = true } = options;
  // const bundleUseGreaterModel = softBundleUtils.isSoftBundleBizPlus() || softBundleUtils.isBrickMortar();
  const callingPlans = computedCallingPlans(store.getters.getSelectedPlans);
  const callingSum = callingPlans.reduce((pre, curVal) => (curVal?.cartInfo?.selected_number || 0) + pre, 0)
  const selectedDeskPhones = store.getters.getSelectedPlans.filter(item => item.type === planTypes.ZOOM_DEVICE$DESK_PHONE);
  const deskphoneSum = selectedDeskPhones.reduce((pre, curVal) => (curVal?.cartInfo?.selected_number || 0) + pre, 0)
  const selectedHeadsets = store.getters.getSelectedPlans.filter(item => item.type === planTypes.ZOOM_DEVICE$HEADSET);
  const headsetSum = selectedHeadsets.reduce((pre, curVal) => (curVal?.cartInfo?.selected_number || 0) + pre, 0)

  await validateDeviceLicense(
    {
      callingSum,
      deskphoneSum,
      headsetSum,
      emitMessage,
      modal: DEVICE_VALIDATE_MODAL.GREATER
    }
  );
  await validateDeviceMaxLicense({ deskphoneSum, headsetSum, emitMessage });
}
